import { render, staticRenderFns } from "./MobileTemplateEdit.vue?vue&type=template&id=c959b2e6&scoped=true"
import script from "./MobileTemplateEdit.vue?vue&type=script&lang=js"
export * from "./MobileTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./MobileTemplateEdit.vue?vue&type=style&index=0&id=c959b2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c959b2e6",
  null
  
)

export default component.exports